import { Component } from 'react';
import BaseChart from 'legacy/javascripts/components/base_chart.es6';

class AdditionalQuestionNps extends Component {
  labelHandler(e, chart) {
    let chartElement = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false)[0];
    let dataset = chart.data.datasets[chartElement.datasetIndex];
    let label = dataset.label;
    return label;
  }

  render() {
    let options = {
      plugins: {
        legend: { display: false },
        tooltip: {
          mode: 'nearest',
          callbacks: {
            title: function () {
              return '';
            },
            label: tooltipItem => {
              return (
                tooltipItem.chart.data.datasets[tooltipItem.datasetIndex].label.toString() +
                ': ' +
                tooltipItem.formattedValue
              );
            },
          },
        },
      },
      indexAxis: 'y',
      scales: {
        x: { stacked: true },
        y: {
          ticks: { beginAtZero: true },
          stacked: true,
          display: false,
        },
      },
    };

    const extraParams =
      this.props.data.survey_question ?
        { survey_question_id: this.props.data.question_id }
      : { additional_question_id: this.props.data.question_id };

    return (
      <BaseChart
        type="bar"
        id="additionalQuestionNpsDistribution"
        labels={this.props.data.labels}
        datasets={this.props.data.datasets}
        options={options}
        labelParam="additional_question_response_scalar"
        chartHandler={this.props.chartHandler}
        labelHandler={this.labelHandler}
        extraParams={extraParams}
      />
    );
  }
}

export default AdditionalQuestionNps;
